const SUPPORT_EMAIL = 'dealroom@asokoinsight.com'
const SUPPORT_SUBJECT = 'Asoko Support Request'
const DEFAULT_BODY = 'Hello,\n'

const buildMailtoLink = (message = '') => {
  const body = message || DEFAULT_BODY
  return `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(
    SUPPORT_SUBJECT
  )}&body=${encodeURIComponent(body)}`
}

export const contactSupport = (message = '') => {
  console.log('Call contactSupport', message)
  const link = buildMailtoLink(message)
  if (typeof window !== 'undefined') {
    window.location.href = link
  }
  return link
}

export const supportEmail = SUPPORT_EMAIL


